"use strict";
import { gsap, Power3 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper/swiper-bundle";
import * as lock from "./_scrollLock";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);
import "jquery";

// bodyタグを取得
const documentBody = document.querySelector("body");
const loadScreen = document.querySelector(".load-screen");
// bodyタグにclassを付与
documentBody.classList.add("page-loaded");
var fixLoad = function () {
  document.body.classList.remove("is_fade");
  document.body.classList.remove("is_remove");
};
setTimeout(fixLoad, 1000);
// 1.5秒経ったらオーバーレイ非表示
// setTimeout(function () {
//   loadScreen.style.display = "none";
//   newElement1.style.display = "none";
//   newElement2.style.display = "none";
// }, 1500);

// ページ遷移時にフェードアウト
// window.addEventListener(
//   "beforeunload",
//   () => {
//     documentBody.classList.add("is_remove");
//     setTimeout(function () {
//       window.location = url;
//     }, 1000);
//   },
//   false
// );

let anchorTarget = document.querySelectorAll('a:not([href^="#"])');
anchorTarget.forEach((item) => {
  item.addEventListener("click", () => {
    // e.preventDefault();
    let url = item.getAttribute("href");
    // console.log(url);
    if (url !== "") {
      documentBody.classList.add("fadeout");
      setTimeout(function () {
        window.location = url;
      }, 2000);
    }
    return false;
  });
});
window.addEventListener("load", (event) => {
  documentBody.classList.remove("fadeout");
  if (navigator.userAgent.indexOf("iPhone") > 0) {
    let body = document.getElementsByTagName("body")[0];
    body.classList.add("iPhone");
  }

  if (navigator.userAgent.indexOf("iPad") > 0) {
    let body = document.getElementsByTagName("body")[0];
    body.classList.add("iPad");
  }

  if (navigator.userAgent.indexOf("Android") > 0) {
    let body = document.getElementsByTagName("body")[0];
    body.classList.add("Android");
  }
});
// 押下したタブによって中身を切り替える
let tabItem = document.querySelectorAll(".slider-pagination__item");
let contents = document.querySelectorAll(".place-cont");

const nextBtn = document.querySelector(".slider-nav-next");
const prevBtn = document.querySelector(".slider-nav-prev");
const toMovie = document.querySelector(".map-button-movie");

for (let i = 0; i < tabItem.length; i++) {
  tabItem[i].addEventListener(
    "click",
    (e) => {
      let activeTab = document.querySelectorAll(
        ".slider-pagination__item.current"
      );
      const currentTab = document.querySelector(".place-cont.current");
      setTimeout(() => {
        activeTab[0].classList.remove("current");
      }, 50);
      currentTab.classList.remove("current");

      let current = e.currentTarget;
      let activeNumber = current.dataset.tab;
      current.classList.add("current");

      contents[activeNumber].classList.add("current");
      exitAnime();
    },
    false
  );
}
//- 開いているメインコンテンツの中のまだアニメーションが作動していない要素にのみクラスを付与
function exitAnime() {
  let animExit = document.querySelectorAll(".anim--tab");
  animExit.forEach((item) => {
    gsap.to(item, {
      onStart: () => {},
      onComplete: () => {
        item.classList.add("exit");
      },
    });
    item.classList.remove("exit");
  });
}
function moveNext() {
  const activeTab = document.querySelector(".slider-pagination__item.current");
  const activeContent = document.querySelector(".place-cont.current");
  const activeTabData = activeTab.getAttribute("data-tab");
  activeTab.classList.remove("current");
  activeContent.classList.remove("current");
  for (let i = 0; i < tabItem.length; i++) {
    if (activeTabData < tabItem.length - 1) {
      activeTab.nextElementSibling.classList.add("current");
      activeContent.nextElementSibling.classList.add("current");
    } else if (activeTabData > tabItem.length - 2) {
      tabItem[0].classList.add("current");
      contents[0].classList.add("current");
    }
  }
  exitAnime();
}
function movePrev() {
  const activeTab = document.querySelector(".slider-pagination__item.current");
  const activeContent = document.querySelector(".place-cont.current");
  const activeTabData = activeTab.getAttribute("data-tab");
  activeTab.classList.remove("current");
  activeContent.classList.remove("current");
  for (let i = 0; i < tabItem.length; i++) {
    let lastTab = tabItem.length - 1;
    if (activeTabData > 0) {
      activeTab.previousElementSibling.classList.add("current");
      activeContent.previousElementSibling.classList.add("current");
    } else if (activeTabData < 1) {
      tabItem[lastTab].classList.add("current");
      contents[lastTab].classList.add("current");
    }
  }
  exitAnime();
}
nextBtn.addEventListener("click", () => {
  moveNext();
});
if (toMovie != null) {
  toMovie.addEventListener("click", () => {
    moveNext();
  });
}
prevBtn.addEventListener("click", () => {
  movePrev();
});

// document.querySelector(".container__inner").onmousewheel = function () {
//   if (event.wheelDelta > 0) {
//     console.log("下");
//     movePrev();
//   } else {
//     //mainCamera.zoomTo(1, 100);
//     console.log("上");
//     moveNext();
//   }
// };

// map point
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
let mapButton = document.querySelectorAll(".map-button");

mapButton.forEach((item, index) => {
  const mapPointWrap = document.querySelector(".map-point");
  const mapPoint = document.querySelectorAll(".point-text");
  const mapPin = document.querySelectorAll(".map-pin");
  item.addEventListener("mouseenter", () => {
    mapPointWrap.classList.add("is-visible");
    mapPoint[index].classList.add("is-visible");
    mapPin[index].classList.add("is-visible");
  });
  item.addEventListener("mouseleave", () => {
    mapPointWrap.classList.remove("is-visible");
    mapPoint[index].classList.remove("is-visible");
    mapPin[index].classList.remove("is-visible");
  });
  // if (document.querySelector('.minatomirai-4').classList.contains('.is-visible')) {
  //   document
  //     .querySelector(".minatomirai-4")
  //     .nextElementSibling.classList.add(".is-visible");
  // }
});

// modal
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const modalActions = document.querySelectorAll("[data-modal]");
const modalItems = document.querySelectorAll(".modal-wrap");
const closeButton = document.querySelectorAll(".modal-close");

modalActions.forEach((action) => {
  const id = action.dataset.modalContent;
  const modalContent = document.querySelector("#" + id);

  action.addEventListener("click", () => {
    modalContent.classList.add("visible");
    lock.scrollLock();
  });
});

modalItems.forEach((modal) => {
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.classList.remove("visible");
      document.body.classList.remove("is-scroll-locked");
    }
  });
});

closeButton.forEach((close) => {
  close.addEventListener("click", () => {
    const modal = close.closest(".modal-wrap");
    if (modal) {
      modal.classList.remove("visible");
      document.body.classList.remove("is-scroll-locked");
    }
  });
});

// modal youtube
window.addEventListener("DOMContentLoaded", () => {
  $(function () {
    if ($(".js-modal-btn").length) {
      //クラス名js-modal-videoがあれば以下を実行
      $(".js-modal-btn").modalVideo({
        channel: "youtube",
        youtube: {
          rel: 0, //関連動画の指定
          autoplay: 1, //自動再生の指定
          controls: 1, //コントロールさせるかどうかの指定
        },
      });
    }
  });
});
// modal swiper
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
//ラッパー要素を指定
const sliderWrapTw = document.querySelectorAll(".slider-wrap-two");
//サムネイルのスライダーを指定
const sliderThumbTw = document.querySelectorAll(
  ".slider-wrap-two .slider-thumbs"
);
//メインのスライダーを指定
const sliderMainTw = document.querySelectorAll(".slider-wrap-two .slider");
for (let i = 0; i < sliderWrapTw.length; i++) {
  const num = ("00" + (i + 1)).slice(-2);
  sliderWrapTw[i].className += num;
  sliderThumbTw[i].className += num;
  sliderMainTw[i].className += num;
  const swiperThumbTw = new Swiper(".slider-thumbs" + num, {
    slidesPerView: 2,
    spaceBetween: 10,
  });
  const swiperMain = new Swiper(".slider" + num, {
    thumbs: {
      swiper: swiperThumbTw,
    },
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 3000,
    },
    speed: 1000,
    effect: "fade",
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
  });
}

const sliderWrapThe = document.querySelectorAll(".slider-wrap-three");
const sliderThumbThe = document.querySelectorAll(
  ".slider-wrap-three .slider-thumbs-three"
);
const sliderMainThe = document.querySelectorAll(
  ".slider-wrap-three .slider-three"
);
for (let i = 0; i < sliderWrapThe.length; i++) {
  const num = ("00" + (i + 1)).slice(-2);
  sliderWrapThe[i].className += num;
  sliderThumbThe[i].className += num;
  sliderMainThe[i].className += num;
  const swiperThumbThe = new Swiper(".slider-thumbs-three" + num, {
    slidesPerView: 3,
    spaceBetween: 10,
  });
  const swiperMain = new Swiper(".slider-three" + num, {
    thumbs: {
      swiper: swiperThumbThe,
    },
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 3000,
    },
    speed: 1000,
    effect: "fade",
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
  });
}

const sliderWrapFor = document.querySelectorAll(".slider-wrap-four");
const sliderThumbFor = document.querySelectorAll(
  ".slider-wrap-four .slider-thumbs-four"
);
const sliderMainFor = document.querySelectorAll(
  ".slider-wrap-four .slider-four"
);
for (let i = 0; i < sliderWrapFor.length; i++) {
  var num = ("00" + (i + 1)).slice(-2);
  sliderWrapFor[i].className += num;
  sliderThumbFor[i].className += num;
  sliderMainFor[i].className += num;
  const swiperThumbFor = new Swiper(".slider-thumbs-four" + num, {
    slidesPerView: 4,
    spaceBetween: 10,
  });
  const swiperMain = new Swiper(".slider-four" + num, {
    thumbs: {
      swiper: swiperThumbFor,
    },
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 3000,
    },
    speed: 1000,
    effect: "fade",
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
  });
}
